import React, { use, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { restRequest } from '../../../Helpers/RequestHelper';
import { withFormik } from 'formik';
import {
  required,
  ValidateName,
  ValidatePercentage,
  ValidateMax50,
} from '../../../Helpers/Validator';
import { validateCreateTaxorm } from '../../../Helpers/FormValidator';
import { confirmationAlert } from '../../../Helpers';
import { Field, Form, FormAction, ErrorFocus } from '../';
import { useTranslation } from 'react-i18next';
import Switch from '../../Switch/Switch';
import { getDiscountOptions } from '../../../Constants';

const formEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    name: required(ValidateName),
    rate: required(ValidatePercentage),
    authority: ValidateMax50,
  }),
  mapPropsToValues: ({ tax }) => ({
    ...tax,
  }),
  handleSubmit: (values, bag) => {
    handleFormSubmit(values, bag);
  },
});

const handleFormSubmit = (
  values,
  {
    setSubmitting,
    props: {
      requestType,
      requestUrl,
      inModal,
      onSubmitModal,
      taxValueFetchAutomatically = () => null,
      history,
      successMessage,
      handleToast,
    },
  }
) => {
  const { name, rate, authority } = values;
  restRequest(requestType, requestUrl, {
    name,
    rate,
    authority,
    type: values.isFixedTax,
  })
    .then((res) => {
      if (inModal) {
        onSubmitModal(res.data);
        taxValueFetchAutomatically(res.data);
        if (history?.location?.pathname.includes('/taxes')) {
          history.push('/taxes');
        }
      } else {
        history.push('/taxes');
      }
      successMessage();
    })
    .catch((error) => {
      let errorMess = error?.response?.data?.errors?.name[0];
      if (errorMess && errorMess === 'The name has already been taken.') {
        handleToast(`Tax of the same name is already added`, 'error');
      } else {
        handleToast(error?.response?.data?.message, 'error');
      }
      setSubmitting(false);
    });
};

const closeAndBack = (history, closeModal, totalRecords, modelSource) => {
  if (!modelSource) {
    closeModal();
  } else {
    closeModal();
    if (totalRecords === undefined || totalRecords === 0) {
      history.push('/settings');
    }
  }
};

const TaxForm = (props) => {
  const {
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    isSubmitting,
    submitCount,
    errors,
    touched,
    // custom props
    inModal,
    closeModal,
    history,
    title,
    totalRecords,
    enableFixedTax,
    modelSource = '',
    handlePrompt,
  } = props;
  const { t } = useTranslation();
  const [staticVal, setStaticValues] = useState({});
  // const currency = localStorage.getItem('currentOrganization')
  //   ? JSON.parse(localStorage.getItem('currentOrganization'))?.get_currency
  //   : null;
  const TaxTypeOptions = [
    { label: t('Preferences.Percentage'), value: 'percentage' },
    { label: t('Preferences.Amount'), value: 'fixed' },
  ];
  useEffect(() => {
    handleAlert();
    // eslint-disable-next-line
  }, [values, staticVal]);

  useEffect(() => {
    setStaticValues(values);
    // eslint-disable-next-line
  }, []);

  const handleAlert = () => {
    let { checkout } = validateCreateTaxorm(values, staticVal);
    handlePrompt(!checkout);
    return checkout;
  };

  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', unloadCallback);
    return () => window.removeEventListener('beforeunload', unloadCallback);
  }, []);

  const handleCancel = () => {
    let status = handleAlert();
    let response = true;
    if (!status) {
      response = confirmationAlert();
    }
    if (status || response) {
      if (inModal) closeAndBack(history, closeModal, totalRecords, modelSource);
      else history.push('/taxes');
    }
  };

  return (
    <Form title={title} onSubmit={handleSubmit} className="tax-form">
      <div className="form-fields-container d-flex flex-wrap  position-relative w-100">
        <Field
          autoFocus={true}
          className="flex-25"
          name={t('Settings.tax_name')}
          value={values.name}
          id="name"
          required
          handleChange={handleChange}
          error={touched.name && errors.name}
          onBlur={handleBlur}
        />
        <Field
          className="flex-25"
          type="number"
          name={t('Settings.tax_rate')}
          value={values.rate}
          decimalScale={2}
          id="rate"
          // suffix={values.isFixedTax ? '' : '%'}
          required
          onValueChange={(value) => setFieldValue('rate', value.floatValue)}
          onBlur={handleBlur}
          error={(touched.rate || submitCount > 0) && errors.rate}
        />

        <Field
          style={{ marginTop: '30px' }}
          className="flex-25"
          type="dropdown"
          name={t('Settings.type')}
          id="isFixedTax"
          disabled={!enableFixedTax}
          value={values.isFixedTax}
          options={TaxTypeOptions}
          dropdownValue="value"
          dropdownLabel="label"
          handleChange={(option) => setFieldValue('isFixedTax', option.value)}
          // addButton={inModal ? false : true}
        />

        <Field
          className="flex-25"
          name={t('Settings.tax_authority')}
          value={values.authority}
          id="authority"
          handleChange={handleChange}
          onBlur={handleBlur}
          error={touched.authority && errors.authority}
        />
      </div>

      <FormAction disabled={isSubmitting} onCancel={handleCancel} />
      <ErrorFocus />
    </Form>
  );
};

export default formEnhancer(TaxForm);
